export default __webpack_public_path__ + "static/media/facility-name.d12e1bf8.png";